import { squareBlockCSS, Typography } from '@braskai/ui-kit';

import { Box, css, styled } from '@mui/material';

export const SLinkContainer = styled(Box)(
  () => css`
    transition: width 0.3s;

    > a {
      height: 100%;
      display: block;
      overflow: hidden;
      text-decoration: none;
      line-height: 0;

      > svg {
        width: 128px;
        height: 24px;
      }
    }
  `,
);

export const SWhiteLabelIcon = styled(Box)(
  () => css`
    ${squareBlockCSS(32)};
    background: linear-gradient(137deg, #6a6aff 24.15%, #0b0bcf 100%);
    border-radius: 6px;
  `,
);

export const SWhiteLabelLogo = styled(Typography)(
  () => css`
    gap: 8px;
    white-space: nowrap;
    line-height: 17px;
  `,
);
